import React from "react";

import type { CaptionedImageBlock } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import styles from "./CaptionedImageGrid.module.scss";

export const CaptionedImageGrid = ({
    items,
}: {
    items: CaptionedImageBlock[];
}) => (
    <ul className={styles.grid}>
        {items.map((item, index) => (
            <li key={index}>
                {item.label && <p className={styles.label}>{item.label}</p>}
                {item.image && (
                    <ImageChooserBlock
                        value={item.image}
                        attrs={{ className: styles.picture }}
                        imageAttrs={{ className: styles.image }}
                    />
                )}
                {item.caption && (
                    <p className={styles.caption}>{item.caption}</p>
                )}
            </li>
        ))}
    </ul>
);
